import React from 'react';
import Button from '../components/Button';
import styles from './DropLine.module.scss';

interface DropLineProps {
  message: string;
}

const DropLine = ({ message }: DropLineProps) => (
  <div className={styles.container}>
    <p className={styles.text}>{message}</p>
    <Button
      className={styles.button}
      size="small"
      to="mailto:support@slab.com"
      variant="secondary"
    >
      Drop us a line
    </Button>
  </div>
);

export default DropLine;
